import './welcome.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../common/components/card';
import { ReactComponent as AmbevUserIcon } from '../../common/assets/svg/ambev-user.svg';
import { ReactComponent as PartnerUserIcon } from '../../common/assets/svg/partner-user.svg';
import LOGO from '../../common/assets/png/logo.png';
import generateAuthURL from '../../utils/authMethods';
import Auth from '../../app/contexts/auth';
import HomeConstants from '../home/constants';
import ToastBase from '../../common/components/toast-base';
import Text from '../../common/components/text';
import { realmType } from '../../utils/configurationManager';

export default function Welcome() {
    const { user } = Auth.useAuth();
    const [isfailedLogin, setIsfailedLogin] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const {
        t,
        i18n: { changeLanguage },
    } = useTranslation();

    const verifyLanguageDefault = useCallback(() => {
        const languageInLocalStorage = localStorage.getItem(
            'UserLanguageSelected',
        );

        if (languageInLocalStorage == null) {
            localStorage.setItem('UserLanguageSelected', 'pt-BR');
            changeLanguage(
                localStorage.getItem('UserLanguageSelected') ?? 'pt-BR',
            );
        } else {
            changeLanguage(languageInLocalStorage);
        }
    }, [changeLanguage]);

    useEffect(() => {
        verifyLanguageDefault();
        if (user) {
            navigate(HomeConstants.PATH);
        } else if (location.state === 'login_failed') {
            setIsfailedLogin(true);
            window.history.replaceState({}, document.title);
        }
    }, [user, navigate, location, verifyLanguageDefault, setIsfailedLogin]);

    const login = async (accessType: realmType) => {
        sessionStorage.setItem('UserType', accessType);
        window.location.href = await generateAuthURL(accessType);
    };

    function renderFailedToast() {
        return (
            isfailedLogin && (
                <ToastBase
                    className=""
                    type="negative"
                    title={t('ErroLogin')}
                    description={t('UsuarioSemAcesso')}
                />
            )
        );
    }

    return (
        <>
            {renderFailedToast()}

            <div className="welcome-container" data-testid="welcome">
                <img src={LOGO} alt="Logo SULA" className="logo" />

                <Text className="welcome-title" value={t('BemvindoSula')} />
                <Text
                    className="welcome-title"
                    value={t('BemvindoDescricao')}
                />

                <div className="welcome-cards">
                    <Card
                        className="welcome-card"
                        data-testid="card-ambev"
                        onClick={() => login('ambev')}
                    >
                        <AmbevUserIcon className="user-icon" />
                        <p className="welcome-card-title">{t('AmbevUser')}</p>
                    </Card>
                    <Card
                        className="welcome-card"
                        data-testid="card-partner"
                        onClick={() => login('third')}
                    >
                        <PartnerUserIcon className="user-icon" />
                        <p className="welcome-card-title">
                            {t('AmbevUserParceiro')}
                        </p>
                    </Card>
                </div>
            </div>
        </>
    );
}
